import { useTranslation } from 'react-i18next';
import { fmtScore } from '@/utils/analytics';

const TOP_COLORS = ['var(--cp-success)', '#10b981', '#34d399', '#6ee7b7', '#a7f3d0'];
const BOT_COLORS = ['var(--cp-danger-light)', '#f59e0b', '#fbbf24', '#fcd34d', '#fde68a'];

interface BehaviorAvg {
  id: string;
  name: string;
  fundId: string;
  fundColor: string;
  fundShort: string;
  count: number;
  avg: number;
}

interface TopBotBehaviorsProps {
  topBehaviors: BehaviorAvg[];
  bottomBehaviors: BehaviorAvg[];
}

export function TopBotBehaviors({ topBehaviors, bottomBehaviors }: TopBotBehaviorsProps) {
  const { t } = useTranslation();

  return (
    <div className="au-topbot">
      <div className="au-topbot-card">
        <div className="au-topbot-title" style={{ color: 'var(--cp-success)' }}>
          <i className="fas fa-arrow-trend-up" aria-hidden="true" />
          {t('analytics.summary.topBehaviors')}
        </div>
        <div className="au-tb-subtitle">{t('analytics.summary.topDailyHabitsSubtitle')}</div>
        <div className="au-tb-list">
          {topBehaviors.map((b, idx) => (
            <div key={b.id} className="au-tb-item">
              <div className="au-tb-rank" style={{ background: TOP_COLORS[idx] }}>
                {idx + 1}
              </div>
              <div className="au-tb-dot" style={{ background: b.fundColor }} />
              <div className="au-tb-info">
                <strong>{b.name}</strong>
                <span>{b.fundShort} · {b.count} eval</span>
              </div>
              <span className="au-tb-score" style={{ color: 'var(--cp-success)' }}>
                {fmtScore(b.avg)}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="au-topbot-card">
        <div className="au-topbot-title" style={{ color: 'var(--cp-danger-light)' }}>
          <i className="fas fa-arrow-trend-down" aria-hidden="true" />
          {t('analytics.summary.opportunities')}
        </div>
        <div className="au-tb-subtitle">{t('analytics.summary.oppSubtitle')}</div>
        <div className="au-tb-list">
          {bottomBehaviors.map((b, idx) => (
            <div key={b.id} className="au-tb-item">
              <div className="au-tb-rank" style={{ background: BOT_COLORS[idx] }}>
                {idx + 1}
              </div>
              <div className="au-tb-dot" style={{ background: b.fundColor }} />
              <div className="au-tb-info">
                <strong>{b.name}</strong>
                <span>{b.fundShort} · {b.count} eval</span>
              </div>
              <span className="au-tb-score" style={{ color: 'var(--cp-danger-light)' }}>
                {fmtScore(b.avg)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
